import { render, staticRenderFns } from "./merchantDeductionList.vue?vue&type=template&id=2a735117&"
import script from "./merchantDeductionList.vue?vue&type=script&lang=js&"
export * from "./merchantDeductionList.vue?vue&type=script&lang=js&"
import style0 from "./merchantDeductionList.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports